<template>
  <v-select
    :label="label"
    :outlined="outlined"
    :items="items"
    item-text="name"
    :item-value="multiple ? 'id' : 'name'"
    v-model="selectedLeadSource"
    @change="onChange"
    :clearable="clearable"
    :multiple="multiple"
    :chips="multiple"
    :small-chips="multiple"
    :deletable-chips="multiple"
  ></v-select>
</template>

<script>
import { removeGQLTypename } from "../../../helpers";
import { LEAD_SOURCES_QUERY } from "../../../constants/graphql";

const sortLeadSourcesByName = (leadSourceA, leadSourceB) => {
  return leadSourceA.name > leadSourceB.name ? 1 : -1;
};

export default {
  name: "lead-source-list-select",

  props: {
    outlined: {
      type: Boolean,
      default: () => false,
    },
    // a name, or an array of lead source ids when multiple
    value: {
      type: [String, Array],
      default: () => "",
    },
    // #11392 select several lead sources, v-model is then an array of ids
    multiple: {
      type: Boolean,
      default: () => false,
    },
    clearable: {
      type: Boolean,
      default: () => true,
    },
    label: {
      type: String,
      default: () => "Lead Source",
    },
  },

  data() {
    return {
      debug: false,
      selectedLeadSource: this.toSelection(this.value),
    };
  },

  computed: {
    items() {
      return this.leadSources && this.leadSources.edges
        ? this.leadSources.edges
            .map(removeGQLTypename)
            .sort(sortLeadSourcesByName)
        : [];
    },
  },

  watch: {
    value(newVal) {
      this.selectedLeadSource = this.toSelection(newVal);
    },
  },

  methods: {
    toSelection(value) {
      if (this.multiple) {
        return Array.isArray(value) ? [...value] : [];
      }
      return value ? value : "";
    },
    onChange() {
      this.$emit(
        "input",
        this.multiple ? this.selectedLeadSource || [] : this.selectedLeadSource
      );
    },
  },

  apollo: {
    leadSources: {
      query: LEAD_SOURCES_QUERY,
      variables() {
        return {
          filter: {},
        };
      },
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/LeadSourceListSelect.vue